export enum RutterConnectionMode {
    Backfill = 'backfill',
    Incremental = 'incremental',
}
